// Données mock pour le site SESAM

export const companyInfo = {
  name: "SESAM",
  tagline: "Votre partenaire en publicité extérieure",
  description: "Leader de l'installation et de la gestion d'espaces publicitaires en Afrique centrale et de l'ouest",
  phone: ["+236 75 50 37 02", "+236 74 36 11 36"],
  email: "sesambangui@gmail.com",
  address: "Av B Boganda, Bangui, République Centrafricaine",
  logo: "https://customer-assets.emergentagent.com/job_crm-showcase-5/artifacts/7pqsxu4w_Logo_PNG.png"
};

export const services = [
  {
    id: 1,
    name: "Panneaux Déroulants",
    price: "4 000 FCFA",
    period: "par affiche/jour",
    pricePerDay: 4000,
    capacity: "Jusqu'à 12 affiches",
    description: "Idéal pour des campagnes multi-produits ou événements avec rotation d'affiches",
    features: [
      "Rotation automatique",
      "Haute visibilité urbaine",
      "Installation stratégique",
      "Maintenance incluse"
    ],
    image: "https://customer-assets.emergentagent.com/job_crm-showcase-5/artifacts/8a32i3cy_11062FAD-C8BF-41B2-9E19-490FD5854A6C.png",
    popular: false
  },
  {
    id: 2,
    name: "Panneaux LED",
    price: "3 000 FCFA",
    period: "par affiche/jour",
    pricePerDay: 3000,
    capacity: "Jusqu'à 10 affiches",
    description: "Technologie LED moderne pour un impact visuel maximal jour et nuit",
    features: [
      "Affichage numérique",
      "Visibilité 24/7",
      "Contenu dynamique",
      "Économie d'énergie"
    ],
    image: "https://customer-assets.emergentagent.com/job_crm-showcase-5/artifacts/8r64ok04_D59C4209-92E8-4E07-A19E-ACE030AC42A4.png",
    popular: true
  },
  {
    id: 3,
    name: "Panneaux Grand Format",
    price: "10 000 FCFA",
    period: "par affiche/jour",
    pricePerDay: 10000,
    capacity: "Impact maximal",
    description: "Format géant pour une visibilité incomparable sur les axes majeurs",
    features: [
      "Visibilité à grande distance",
      "Emplacements premium",
      "Impact publicitaire fort",
      "Couverture maximale"
    ],
    image: "https://customer-assets.emergentagent.com/job_crm-showcase-5/artifacts/8mjvmr2p_IMG_2655.jpeg",
    popular: false
  },
  {
    id: 4,
    name: "Panneaux Poteaux",
    price: "5 000 FCFA",
    period: "par affiche/jour",
    pricePerDay: 5000,
    capacity: "Jusqu'à 25 affiches par emplacement",
    description: "Panneaux urbains sur poteaux pour une présence stratégique sur les avenues principales",
    features: [
      "Visibilité piétonne optimale",
      "Emplacements stratégiques",
      "Grande capacité d'affichage",
      "Installation sur axes majeurs"
    ],
    image: "https://customer-assets-cm19k8pv.emergentagent.net/job_crm-showcase-5/artifacts/p5pwmf2g_A58D5933-21B0-4ED5-8E31-8A8E79B49652.png",
    popular: false
  }
];

export const franchises = [
  {
    id: 1,
    country: "Tchad",
    city: "N'Djamena",
    flag: "🇹🇩"
  },
  {
    id: 2,
    country: "Guinée Conakry",
    city: "Conakry",
    flag: "🇬🇳"
  },
  {
    id: 3,
    country: "République Centrafricaine",
    city: "Bangui",
    flag: "🇨🇫",
    headquarters: true
  }
];

export const partners = [
  "Entreprises locales",
  "ONG internationales",
  "Organisations gouvernementales",
  "Sociétés multinationales",
  "Agences de communication"
];

export const stats = [
  {
    id: 1,
    value: "100+",
    label: "Panneaux installés",
    description: "À travers 3 pays"
  },
  {
    id: 2,
    value: "200+",
    label: "Clients satisfaits",
    description: "Entreprises et ONG"
  },
  {
    id: 3,
    value: "3",
    label: "Pays couverts",
    description: "Afrique centrale et de l'ouest"
  },
  {
    id: 4,
    value: "15+",
    label: "Années d'expérience",
    description: "Dans la publicité extérieure"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marie Kouassi",
    company: "Orange Money",
    role: "Directrice Marketing",
    content: "SESAM nous a permis d'augmenter notre visibilité de façon spectaculaire. Leurs panneaux LED sont d'une qualité exceptionnelle.",
    rating: 5
  },
  {
    id: 2,
    name: "Jean-Pierre Dembélé",
    company: "Coca-Cola Central Africa",
    role: "Responsable Communication",
    content: "Un partenaire fiable et professionnel. La couverture multi-pays est un atout majeur pour nos campagnes régionales.",
    rating: 5
  },
  {
    id: 3,
    name: "Aminata Traoré",
    company: "UNICEF",
    role: "Coordinatrice Communication",
    content: "Excellente collaboration pour nos campagnes de sensibilisation. SESAM comprend nos besoins et y répond avec efficacité.",
    rating: 5
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Couverture régionale",
    description: "Présents dans 5 pays d'Afrique avec des emplacements stratégiques",
    icon: "Globe"
  },
  {
    id: 2,
    title: "Technologie moderne",
    description: "Panneaux LED et équipements de dernière génération",
    icon: "Zap"
  },
  {
    id: 3,
    title: "Service complet",
    description: "De l'installation à la maintenance, nous gérons tout",
    icon: "Settings"
  },
  {
    id: 4,
    title: "Tarifs compétitifs",
    description: "Des solutions adaptées à tous les budgets",
    icon: "DollarSign"
  }
];

export const expertiseHighlights = [
  {
    id: 1,
    title: "Matériaux Premium Importés",
    description: "Nous importons des matériaux de qualité supérieure pour garantir la durabilité et la résistance de nos panneaux aux conditions climatiques africaines.",
    icon: "Package"
  },
  {
    id: 2,
    title: "Fabrication Locale Experte",
    description: "Notre atelier de fabrication à Bangui dispose d'équipements modernes et d'une équipe de techniciens hautement qualifiés.",
    icon: "Wrench"
  },
  {
    id: 3,
    title: "Contrôle Qualité Rigoureux",
    description: "Chaque panneau passe par plusieurs étapes de vérification avant installation pour assurer une qualité irréprochable.",
    icon: "CheckCircle"
  },
  {
    id: 4,
    title: "Installation Professionnelle",
    description: "Nos équipes d'installation certifiées garantissent une mise en place sécurisée et conforme aux normes internationales.",
    icon: "Hammer"
  }
];

export const workshopImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_crm-showcase-5/artifacts/08b73554_IMG_1381.jpeg",
    title: "Atelier de fabrication",
    description: "Nos techniciens qualifiés assemblent chaque panneau avec précision"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_crm-showcase-5/artifacts/rxep10vi_IMG_1382.jpeg",
    title: "Contrôle qualité",
    description: "Vérification minutieuse avant livraison"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_crm-showcase-5/artifacts/wya37g2g_b42478c4-54fa-414d-b851-1c9bf9675260.jpeg",
    title: "Panneaux haute qualité",
    description: "Design élégant et structure robuste"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_crm-showcase-5/artifacts/wpywxfae_13414b35-fa5c-489c-bc60-efd3245ffc7c.jpeg",
    title: "Clients prestigieux",
    description: "Projets gouvernementaux et institutionnels"
  }
];

export const qualityFeatures = [
  "Matériaux résistants aux intempéries et UV",
  "Structures en acier galvanisé anti-corrosion",
  "Systèmes d'éclairage LED économes en énergie",
  "Garantie constructeur de 5 ans",
  "Maintenance préventive incluse",
  "Conformité aux normes internationales"
];
